/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandFramer = createReactComponent("outline", "brand-framer", "IconBrandFramer", [["path", { "d": "M6 15h12l-12 -12h12v6h-12v6l6 6v-6", "key": "svg-0" }]]);

export { IconBrandFramer as default };
//# sourceMappingURL=IconBrandFramer.mjs.map
